import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { isJsonObject } from "../../../api/http/jsonDecoding";
import { appPaths } from "../../../shared/routing/appPaths";
import { notifyReleasesChanged } from "./releaseChanges";

/**
 * A release the release Workflow's step made (its `release` value), as the Thread shows it: a
 * link to the release. Shown, it tells the Data model's releases list and the settings' Export section to read
 * the releases again, as the dialog did when it made one.
 */
export default function ReleaseMade({ value }: { value: unknown }) {
  const { t } = useTranslation();
  const release = readRelease(value);
  const datasetId = release?.datasetId ?? null;
  const number = release?.version ?? null;
  useEffect(() => {
    if (datasetId !== null && number !== null) notifyReleasesChanged();
  }, [datasetId, number]);
  if (release === null) return null;
  return (
    <Link to={appPaths.release(release.datasetId, release.version)} className="app-link text-xs underline">
      {t("data.release.numberWithTitle", { number: release.version, title: release.title })}
    </Link>
  );
}

function readRelease(value: unknown): { datasetId: string; version: number; title: string } | null {
  if (!isJsonObject(value)) return null;
  const { dataset_id: datasetId, version, title } = value;
  return typeof datasetId === "string" && typeof version === "number" && typeof title === "string" ? { datasetId, version, title } : null;
}
